const studentRoutes = [
    // HOME
    {
        path: '/student/home',
        name: 'student.home',
        component: () => import('@/views/student/Home'),
        meta: {
            drawer: true,
            footer: true,
        }
    },

    // COACHES
    {
        path: '/student/coaches',
        name: 'student.coaches',
        component: () => import('@/views/student/Coachs'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/student/coaches/:uid/',
        name: 'student.coach-profile',
        component: () => import('@/views/student/CoachProfile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // CHATS
    {
        path: '/student/chats',
        name: 'student.chats',
        component: () => import('@/views/student/Chats'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // ROUTINES
    {
        path: '/student/routines',
        name: 'student.routines',
        component: () => import('@/views/student/Routines'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/student/routines/:uid',
        name: 'student.routine.detail',
        component: () => import('@/views/student/RoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/student/routines/:uid/exercise/:id',
        name: 'student.routine.detail.exercise',
        component: () => import('@/views/student/ExerciseDetail'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // COMPETENCES
    {
        path: '/student/routines/competence/:uid',
        name: 'student.routine.competence.detail',
        component: () => import('@/views/student/CompetenceDetail'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },


    // STATISTICS
    {
        path: '/student/statistics',
        name: 'student.statistics',
        component: () => import('@/views/student/Statistics'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // PROFILE
    {
        path: '/student/profile',
        name: 'student.profile',
        component: () => import('@/views/student/Profile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/student/profile/:mode',
        name: 'student.profile.edit',
        component: () => import('@/views/student/EditProfile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // INVITATIONS
    {
        path: '/student/invitations',
        name: 'student.invitations',
        component: () => import('@/views/student/StudentInvitations'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
]

export default studentRoutes;